/*
 *
 * LanguageProvider actions
 *
 */

import { CHANGE_LOCALE } from './constants';

export function changeLocaleAction(languageLocale: string) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}
